import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import anime from 'animejs/lib/anime.es.js';

export default function NotFoundPage() {
  const containerRef = useRef(null);

  useEffect(() => {
    document.title = 'Signal Lost // VVS';
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !containerRef.current) return;

    anime.timeline({ easing: 'easeOutExpo' })
      .add({ targets: '.nf-title', translateY: [60, 0], opacity: [0, 1], duration: 1200 })
      .add({ targets: '.nf-text', translateY: [30, 0], opacity: [0, 1], duration: 800, delay: anime.stagger(100) }, '-=600')
      .add({ targets: '.nf-cta', scale: [0.9, 1], opacity: [0, 1], duration: 600 }, '-=200');
  }, []);

  return (
    <div 
      ref={containerRef}
      style={{ 
        position: 'relative', 
        zIndex: 1, 
        paddingTop: '64px',
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '80px 48px',
      }}
      data-testid="not-found-page"
    >
      {/* Main title */}
      <h1 
        className="nf-title neon-heading" 
        style={{
          fontSize: 'clamp(24px, 5vw, 48px)',
          lineHeight: 1.1,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          marginBottom: '48px',
          opacity: 0,
        }}
      >
        YOU DRIFTED TOO FAR FROM THE SIGNAL.
      </h1>

      {/* Description */}
      <div style={{ maxWidth: '500px', marginBottom: '48px' }}>
        <p 
          className="nf-text"
          style={{
            fontFamily: 'Space Grotesk',
            fontSize: 'clamp(14px, 2vw, 18px)',
            lineHeight: 1.9,
            color: 'var(--vvs-steel)',
            marginBottom: '20px',
            opacity: 0,
          }}
        >
          The frequency you're looking for<br />
          doesn't exist here.
        </p>
        <p 
          className="nf-text"
          style={{
            fontFamily: 'Space Grotesk',
            fontSize: 'clamp(14px, 2vw, 18px)',
            lineHeight: 1.9,
            color: 'var(--vvs-muted)',
            opacity: 0,
          }}
        >
          Or not yet.
        </p>
      </div>

      {/* CTA */}
      <Link 
        to="/" 
        className="nf-cta btn-metallic btn-metallic-filled" 
        data-testid="return-home-btn"
        style={{ 
          textDecoration: 'none', 
          opacity: 0,
        }}
      >
        ← Return to the wave
      </Link>
    </div>
  );
}
